import { useEffect } from 'react';
import { useInfiniteHits } from 'react-instantsearch';

const useCustomInfiniteHits = () => {
  const { hits, showMore, isLastPage } = useInfiniteHits();

  useEffect(() => {
    const target = document.getElementById("TheMostImportantCatalogues");
    if (target) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLastPage && showMore) {
            // showMore();
            setTimeout(() => {
              showMore();
            }, 500);
          }
        });
      });

      observer.observe(target);

      return () => {
        observer.disconnect();
      };
    }
  }, [isLastPage, showMore]);

  return {
    hits
  }
}

export default useCustomInfiniteHits